import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Converts a px value (authored at 16px root) into the equivalent px at the
// current root font-size. At <=1920px viewport root font-size is 16px so this
// returns the same number; above 1920px it scales up with the html clamp.
const rem = (px) => {
    const root = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return (px / 16) * root;
};

// Collected Swiper instances so we can update them when the viewport (and
// therefore root font-size) changes.
const sliderInstances = [];

const siteSliders= () => {
    const fullwidthSlider = () => {
        // Variables
        let fullwidthSliders = document.querySelectorAll('.fws-slider');
        // Check if USP sliders exist
        if (fullwidthSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        fullwidthSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 0,
                slidesPerView: 1,
                loop: true,
                speed: 700,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        });
    };

    const termpostSlider = () => {
        // Variables
        let termpostSliders = document.querySelectorAll('.termpost-wrapper');
        // Check if USP sliders exist
        if (termpostSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        termpostSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: rem(8),
                slidesPerView: 1.2,
                loop: true,
                speed: 700,
                navigation: {
                    nextEl: '.termpost-btn-next',
                    prevEl: '.termpost-btn-prev',
        },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        loop: true,
                    },
                    992: {
                        slidesPerView: 3,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 4,
                        loop: false,
                    },
                },
            });
            sliderInstances.push({ instance: swiperSlide, baseSpace: 8 });
        });
    };

    const termpostSliderTc = () => {
        // Variables
        let termpostSlidersTc = document.querySelectorAll('.termpost-wrapper-tc');
        // Check if USP sliders exist
        if (termpostSlidersTc.length === 0) {
            return;
        }
        // Loop through each USP slider
        termpostSlidersTc.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: rem(8),
                slidesPerView: 1.2,
                loop: true,
                speed: 700,
                navigation: {
                    nextEl: '.termpost-btn-next',
                    prevEl: '.termpost-btn-prev',
            },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        loop: true,
                    },
                    992: {
                        slidesPerView: 3,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 2,
                        loop: false,
                    },
                },
            });
            sliderInstances.push({ instance: swiperSlide, baseSpace: 8 });
        });
    };

    // Init Functions
    fullwidthSlider();
    termpostSlider();
    termpostSliderTc();
};

document.addEventListener('DOMContentLoaded', () => {
    siteSliders();
});

// Recompute spaceBetween on resize so sliders stay in sync with the fluid
// root font-size above 1920px. Debounced to avoid thrashing.
let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        sliderInstances.forEach(({ instance, baseSpace, lgSpace }) => {
            if (!instance || instance.destroyed) return;
            const isLg = window.innerWidth >= 992 && lgSpace;
            instance.params.spaceBetween = rem(isLg ? lgSpace : baseSpace);
            instance.update();
        });
    }, 150);
});

